<script setup>
import { useDetailsReport } from '#/detailsReport/useDetailsReport'
import { inject } from 'vue'
import { useFilters } from '#/general/useFilters'
import PotentialLineItem from '#/detailsReport/PotentialLineItem'

const { potential } = useDetailsReport()
const { prettifyNumber } = useFilters()
const { global } = inject('Shared')
</script>

<template lang="pug">
.infoBox(v-if="potential")
  .box(style="width: 100%;")
    .boxLabel.q-mb-sm Eckdaten
    potential-line-item(label="Gebäudeklasse:" tooltip="Einteilung der Gebäude nach EUROSTAT-Klassifikation+." :val="potential.buildings[0].buildingCategory")
    potential-line-item(label="Parzellen-Nummer:" tooltip="Die eindeutige Parzellen-Nummer der Gemeinde, in welcher sich die abgefragte Liegenschaft befindet." :val="`${potential.parcel.parcelNr ? potential.parcel.parcelNr : 'Unknown'}`")
    potential-line-item(label="Baujahr:" :val="potential.yearOfConstructionEndMax")
    potential-line-item(label="Grundstücksfläche:" :val="(prettifyNumber(potential.parcel.area, 2))" unit="m" small-text="2")
    potential-line-item(label="Anzahl Wohnungen:" :val="potential.buildings[0].apartments")
    potential-line-item(label="Gebäudegrundfläche:" tooltip="Die Gebäudegrundfläche ist gemäss SIA 416 jene Fläche des Grundstücks, welche von Gebäuden oder Gebäudeteilen durchdrungen wird." :val="prettifyNumber(potential.parcel.builtUpArea, 1)" unit="m" small-text="2")
    potential-line-item(label="Letzte Sanierung:" tooltip="Angabe der Jahreszahl zur letzten, Baugesuchs-pflichtigen Sanierung oder Erneuerung der Liegenschaft oder Teilen davon." :val="potential.buildings[0].yearOfRenovationEnd")
    potential-line-item(label="Kommunale Bauzone:" tooltip="Die auf Gemeindeebene definierte Bauzone, in welcher sich die abgefragte Liegenschaft befindet.")
      .full-width
        template(v-for="(potentialBuildingZone, index) in potential.buildingZones" :key="index")
          .itemValue(v-if="potentialBuildingZone.buildingZone")
            span.relative-position  {{ `${potentialBuildingZone.buildingZone.shortName} (${potentialBuildingZone.squareMeters}m` }}
              .smallText 2
            span.q-pl-sm )
    potential-line-item(:clickable="true" tooltip="Der ÖREB-Auszug gibt Auskunft über die öffentlich-rechtlichen Eigentumsbeschränkungen, welche die abgefragte  Liegenschaft betreffen." label="ÖREB Auszug:" :val="potential.oerebPdfCdnUrl ? `https://raumpionierestorage.blob.core.windows.net${potential.oerebPdfCdnUrl}` : potential.oerebLink" :url-headers="potential.oerebLinkHeaders")
    potential-line-item(:clickable="true" tooltip="Das Baureglement der Gemeinde bildet die rechtliche Grundlage und reglementiert insbesondere das Bauen innerhalb der Bauzonen." label="Baureglement Gemeinde:" :val="potential.city ? potential.city.buildingRegulationsPage : null")
</template>

<style scoped lang="sass">
.infoBox
  @media screen and (min-width: 1440px)
    margin-bottom: 40px
    width: calc(50% - 16px)
  @media screen and (max-width: 1440px)
    margin-bottom: 20px
    width: 100%
  .box
    position: relative
    background: rgba(255, 255, 255, 0.9)
    border: 1px solid #D9D9D9
    box-sizing: border-box
    box-shadow: 0px 15px 30px rgba(166, 166, 166, 0.25)
    border-radius: 10px
    @media screen and (min-width: 1440px)
      padding: 20px 40px
      height: 470px
    @media screen and (max-width: 1440px)
      padding: 15px 20px 15px 20px
    .boxLabel
      font-style: normal
      font-weight: bold
      font-size: 16px
      line-height: 130%
      text-transform: uppercase
      color: #626C85
      margin: 10px 0 10px 0
  .itemValue
    font-style: normal
    font-weight: 500
    font-size: 16px
    line-height: 130%
    color: v-bind('global.graphicElementColor')
    position: relative
    .smallText
      position: absolute
      top: -4px
      right: -7px
      font-size: 10px
</style>
